import styled, { css, keyframes } from "styled-components";

const BRAND_GRADIENT = 'linear-gradient(90deg, #367eee 0%, #b74bff 50.96%, #feb508 100%)';
const GRADIENT_BORDER_BACKGROUND = `linear-gradient(var(--white), var(--white)) padding-box, ${BRAND_GRADIENT} border-box`;

const ACTION_BLUE = '#2D7FF9';
const ACTION_BLUE_HOVER = '#1c6de0';
const ACCENT_PURPLE = '#b74bff';
const LINKEDIN_BLUE = '#0A66C2';
const LINKEDIN_BLUE_HOVER = '#084e96';
const SUCCESS_GREEN = '#2EA37D';
const FOCUS_BLUE = '#3B82F6';

const gradientText = css`
    background: ${BRAND_GRADIENT};
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
`;

const fadeSlideUp = keyframes`
    from{
        opacity: 0;
        transform: translateY(20px);
    }
    to{
        opacity: 1;
        transform: translateY(0);
    }
`;

const spin = keyframes`
    to{
        transform: rotate(360deg);
    }
`;

const pulseGlow = keyframes`
    0%, 100%{
        box-shadow: 0 0 0 0 rgba(183, 75, 255, 0.25);
    }
    50%{
        box-shadow: 0 0 0 6px rgba(183, 75, 255, 0);
    }
`;

export const StyledNewOnboarding = styled.div`
width: 100%;
max-width: 1040px;
min-height: 100vh;
display: flex;
flex-direction: column;
padding: 64px 20px 20px;
margin: 0 auto;

.img-holder img{
    width: 44px;
    height: 44px;
    object-fit: contain;
}

.back-row{
    margin: 4px 0 24px 60px;
}

.back-btn{
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 1px solid var(--gray-350, #e5e7eb);
    background: var(--white);
    border-radius: 999px;
    padding: 8px 18px;
    font-size: 14px;
    font-weight: 500;
    color: var(--black);
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover{
        background: var(--gray-10, #ececec);
    }
}

> .content-holder{
    width: 100%;
    padding: 42vh 0 45vh;

    > *{
        scroll-margin-top: 80px;
    }
}

h1{
    font-size: 50px;
    line-height: 55px;
    text-align: center;
    font-weight: 500;
    animation: ${fadeSlideUp} 1.4s ease both;
}


h2{
    font-size: 36px;
    line-height: 40px;
    font-weight: 400;
    color: var(--gray-50);
    text-align: center;
    margin: 0 0 50px;
    animation: ${fadeSlideUp} 1.4s ease 0.3s both;
}

    .btn-holder button{
        background: ${GRADIENT_BORDER_BACKGROUND};
        border: 1px solid transparent;
        padding: 8px 30px;
        border-radius: 50px;
        position: relative;
        isolation: isolate;
        overflow: hidden;
        cursor: pointer;
        color: var(--black);
        transition: color 0.2s 0.1s;

        &::after{
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 0;
            background: ${BRAND_GRADIENT};
            transition: height 0.3s ease-out;
            z-index: -1;
        }

        &:hover{
            color: var(--white);

            &::after{
                height: 100%;
            }
        }

        &:disabled{
            opacity: 0.45;
            cursor: not-allowed;

            &:hover{
                color: var(--black);

                &::after{
                    height: 0;
                }
            }
        }
    }
`

export const StyledMessage = styled.div`
width: 100%;
display: flex;
position: relative;
padding-left: 60px;
margin: 0 0 24px;
animation: ${fadeSlideUp} 0.4s ease-out;

.img-holder{
    position: absolute;
    top: 0;
    left: 0;
}

.content{
    width: 100%;
    .text-holder{
        max-width: 700px;

    }
    .text{
        display: block;
        font-size: 16px;
        line-height: 20px;
        color: var(--black);
        margin: 0 0 16px;
    }

.video-holder{
    max-width: 600px;
    margin: 0 0 16px;
    border-radius: 12px;
    overflow: hidden;
    background: var(--black);

    video{
        display: block;
        width: 100%;
        height: auto;
    }
}

.btn-holder{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 8px;

}

.chat-input{
    position: relative;
    width: 100%;
    max-width: 920px;
    background: ${GRADIENT_BORDER_BACKGROUND};
    border: 1.5px solid transparent;
    border-radius: 24px;
    padding: 16px 64px 16px 22px;
    margin: 8px 0 0;

    textarea{
        width: 100%;
        border: 0;
        outline: 0;
        resize: none;
        background: transparent;
        font-family: inherit;
        font-size: 16px;
        line-height: 22px;
        color: var(--black);
        min-height: 60px;

        &::placeholder{
            color: var(--gray-50, #9CA3AF);
        }
    }

    .send-btn{
        position: absolute;
        right: 12px;
        bottom: 12px;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 0;
        background: ${ACTION_BLUE};
        color: var(--white);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0;
        transition: background 0.2s ease, opacity 0.2s ease;

        &:hover{
            background: ${ACTION_BLUE_HOVER};
        }

        &:disabled{
            opacity: 0.5;
            cursor: not-allowed;
        }

        svg{
            display: block;
        }
    }

    &.is-url{
        display: flex;
        align-items: center;
        gap: 8px;
        max-width: 480px;
        padding: 8px;
        border-radius: 16px;

        input{
            flex: 1;
            min-width: 0;
            border: 0;
            outline: 0;
            background: var(--gray-10, #ECECEC);
            color: var(--black);
            font-family: inherit;
            font-size: 14px;
            line-height: 18px;
            padding: 10px 18px;
            border-radius: 50px;

            &::placeholder{
                color: var(--gray-50, #9CA3AF);
            }
        }

        .action-btn{
            flex-shrink: 0;
            border: 0;
            background: ${ACTION_BLUE};
            color: var(--white);
            font-family: inherit;
            font-size: 14px;
            font-weight: 500;
            line-height: 18px;
            padding: 10px 22px;
            border-radius: 50px;
            cursor: pointer;
            transition: background 0.2s ease, opacity 0.2s ease;

            &:hover{
                background: ${ACTION_BLUE_HOVER};
            }

            &:disabled{
                opacity: 0.5;
                cursor: not-allowed;
            }
        }
    }
}

}
`

export const StyledUserMessage = styled.div`
width: 100%;
display: flex;
justify-content: flex-end;
margin: 0 0 24px;

.bubble{
    background: var(--gray-10, #ECECEC);
    color: var(--black);
    padding: 10px 22px;
    border-radius: 24px;
    font-size: 14px;
    line-height: 18px;
    word-break: break-word;
}
`

export const StyledProcessingMessage = styled.div`
width: 100%;
display: flex;
flex-direction: column;
align-items: stretch;
margin: 0 0 24px;
animation: ${fadeSlideUp} 0.4s ease-out both;


.processing-pill-wrap{
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 0 0 14px;
}

.processing-pill{
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: ${GRADIENT_BORDER_BACKGROUND};
    border: 1px solid transparent;
    border-radius: 50px;
    padding: 6px 18px;
    font-size: 13px;
    line-height: 16px;
    font-weight: 500;
    color: transparent;
    background-clip: padding-box, border-box;
    -webkit-background-clip: padding-box, border-box;
    animation: ${pulseGlow} 1.6s ease-in-out infinite;

    span{
        ${gradientText}
    }
}

.row{
    width: 100%;
    display: flex;
    position: relative;
    padding-left: 60px;

    .img-holder{
        position: absolute;
        top: 0;
        left: 0;
    }
}

&.inline{
    .processing-pill-wrap{
        padding-left: 0;
    }

    .row{
        padding-left: 0;
    }
}

.card{
    width: 100%;
    max-width: 360px;
    background:
        linear-gradient(var(--white), var(--white)) padding-box,
        linear-gradient(
            135deg,
            #367eee 0%,
            ${ACCENT_PURPLE} 50.96%,
            #feb508 100%
        ) border-box;
    border: 1.5px solid transparent;
    border-radius: 18px;
    padding: 18px 22px;
}

.card-title{
    display: block;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    margin: 0 0 14px;
    background: linear-gradient(
        90deg,
        #367eee 0%,
        ${ACCENT_PURPLE} 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

.step-list{
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.step{
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    line-height: 20px;
    transition: color 0.3s ease;
    position: relative;

    .icon{
        width: 16px;
        height: 16px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .label{
        flex: 1;
    }

    &.pending{
        color: var(--gray-50, #9CA3AF);
    }

    &.active{
        .label{
            ${gradientText}
            font-weight: 500;
        }

        .spinner{
            animation: ${spin} 0.9s linear infinite;
        }
    }

    &.done{
        color: var(--green-100);
    }
}

.check-icon{
    color: ${SUCCESS_GREEN};
}
`

export const StyledProspectsResult = styled.div`
width: 100%;
display: flex;
flex-direction: column;
margin: 0 0 24px;
animation: ${fadeSlideUp} 0.4s ease-out both;

.intro-row{
    width: 100%;
    display: flex;
    position: relative;
    padding-left: 60px;
    margin: 0 0 16px;

    .img-holder{
        position: absolute;
        top: 0;
        left: 0;
    }

    .intro-text{
        display: block;
        font-size: 16px;
        line-height: 22px;
        color: var(--black);
        margin: 0 0 15px;
    }

    .content{
        width: 100%;
    }
}

.table-card{
    background: ${GRADIENT_BORDER_BACKGROUND};
    border: 1.5px solid transparent;
    border-radius: 18px;
    overflow: hidden;
    position: relative;
    margin: 0 0 15px;

    .inner-wrap,
    .inner-wrap > div,
    .inner-wrap > div > div{
        background: var(--white);
    }

    table{
        font-family: inherit;
        color: var(--black);
        font-weight: 400;

        tr{
            border-bottom: 0;
        }
    }


    thead th{
        font-size: 13px !important;
        line-height: 16px;
        font-weight: 500;
        color: var(--gray-300, #777777) !important;
        text-align: left;
        padding: 14px 8px 12px !important;

        &:first-child{
            padding-left: 8px !important;
        }
    }

    tbody td{
        padding: 14px 8px;
        vertical-align: middle;
        font-size: 14px;
        line-height: 18px;
        color: var(--black);
        font-weight: 400;
    }

    tbody tr:last-child td{
        border-bottom: 0;
    }

    .name-cell{
        display: flex;
        align-items: center;
        gap: 10px;
        min-width: 0;

        .avatar{
            width: 36px;
            height: 36px;
            border-radius: 50%;
            overflow: hidden;
            flex-shrink: 0;
            background: var(--gray-100, #f1f1f1);
            display: inline-block;

            img{
                display: block;
                width: 100%;
                height: auto;
                object-fit: cover;
            }

            .initials-avatar{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 13px;
                font-weight: 600;
                text-transform: uppercase;
                line-height: 1;
            }
        }

        .name{
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: var(--black);
            min-width: 0;
        }
    }

    .headline-cell .headline{
        font-size: 14px;
        line-height: 18px;
        color: var(--black);
    }

    .social-cell{
        .social-link{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: ${LINKEDIN_BLUE};
            transition: opacity 0.15s ease;

            &:hover{
                opacity: 0.75;
            }
        }

        .social-empty{
            color: var(--gray-300, #777777);
        }
    }

    .access-btn{
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: var(--white);
        border: 1px solid var(--gray-400, #E6E7EC);
        border-radius: 50px;
        padding: 6px 14px;
        font-size: 12px;
        line-height: 16px;
        color: var(--black);
        cursor: pointer;
        transition: border-color 0.2s ease, color 0.2s ease;

        svg{
            color: var(--gray-300, #777777);
        }

        &:hover{
            border-color: ${ACCENT_PURPLE};
            color: ${ACCENT_PURPLE};

            svg{
                color: ${ACCENT_PURPLE};
            }
        }
    }
}

.lead-pagination{
    display: flex;
    align-items: center;
    gap: 14px;
    margin: 0 0 15px;

    .page-btn{
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: var(--white);
        border: 1px solid var(--gray-400, #E6E7EC);
        border-radius: 50px;
        padding: 7px 16px;
        font-size: 13px;
        line-height: 16px;
        color: var(--black);
        cursor: pointer;
        transition: border-color 0.2s ease, color 0.2s ease;

        &:hover:not(:disabled){
            border-color: ${ACCENT_PURPLE};
            color: ${ACCENT_PURPLE};
        }

        &:disabled{
            opacity: 0.45;
            cursor: not-allowed;
        }
    }

    .page-indicator{
        font-size: 13px;
        color: var(--gray-300, #777777);
    }
}

.btn-holder{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;


}
`

export const StyledCompanyInfoCard = styled.div`
width: 100%;
max-width: 800px;
margin: 8px 0 16px;
padding: 24px;
background: var(--white);
border: 1px solid var(--gray-400, #E6E7EC);
border-radius: 16px;
display: flex;
flex-direction: column;
gap: 18px;

.field{
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.field-label{
    font-size: 14px;
    line-height: 18px;
    color: var(--black);
    font-weight: 400;
}

.field-row{
    display: flex;
    align-items: center;
    gap: 12px;
    background: var(--white);
    border: 1px solid var(--gray-400, #E6E7EC);
    border-radius: 12px;
    padding: 10px 14px;
    transition: border-color 0.2s ease;

    &:focus-within{
        border-color: ${FOCUS_BLUE};
    }
}

.field-value{
    flex: 1;
    font-size: 14px;
    line-height: 20px;
    color: var(--black);
    min-width: 0;
    word-break: break-word;
    white-space: pre-wrap;
}

.field-input{
    flex: 1;
    border: 0;
    outline: 0;
    background: transparent;
    font-family: inherit;
    font-size: 14px;
    line-height: 20px;
    color: var(--black);
    padding: 0;
    min-width: 0;
}

.field-textarea{
    resize: vertical;
    width: 100%;
}

&.multiline .field-row{
    align-items: flex-start;
}

.edit-btn{
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    border: 0;
    background: rgba(59, 130, 246, 0.08);
    color: ${FOCUS_BLUE};
    cursor: pointer;
    flex-shrink: 0;
    font-size: 14px;
    padding: 0;
    transition: background 0.2s ease;

    &:hover{
        background: rgba(59, 130, 246, 0.18);
    }

    svg{
        display: block;
    }
}
`

export const StyledLinkedinFlowReady = styled.div`
width: 100%;
display: flex;
flex-direction: column;
margin: 0 0 24px;
animation: ${fadeSlideUp} 0.4s ease-out both;

.ready-row{
    width: 100%;
    position: relative;
    padding-left: 60px;
    margin: 0 0 18px;
    display: flex;

    .img-holder{
        position: absolute;
        top: 0;
        left: 0;
    }
}

.ready-pill{
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: ${GRADIENT_BORDER_BACKGROUND};
    border: 1.5px solid transparent;
    border-radius: 50px;
    padding: 10px 22px;
    font-size: 14px;
    line-height: 18px;

    .check{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: ${SUCCESS_GREEN};
        font-size: 16px;
    }

    .label{
        ${gradientText}
        font-weight: 500;
    }
}

.diagram-holder{
    width: 100%;
    margin: 0 0 16px;

    img{
        display: block;
        width: 100%;
        height: auto;
    }
}

.meta-text{
    margin: 4px 0 12px 60px;
    font-size: 14px;
    line-height: 18px;
    color: var(--black);
    font-weight: 500;
}

.btn-holder{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 8px;
}
`

export const StyledConnectLinkedIn = styled.div`
width: 100%;
margin: 0 0 24px;
animation: ${fadeSlideUp} 0.4s ease-out both;

.intro-row {
    width: 100%;
    display: flex;
    position: relative;
    padding-left: 60px;
    margin: 0 0 18px;

    .img-holder {
        position: absolute;
        top: 0;
        left: 0;
    }

    .text {
        display: block;
        font-size: 16px;
        line-height: 22px;
        color: var(--black);
    }
}

.connect-card {
    margin-left: 60px;
    max-width: 480px;
    display: flex;
    align-items: center;
    gap: 16px;
    background: var(--white);
    border: 1px solid var(--gray-400, #E6E7EC);
    border-radius: 16px;
    padding: 18px 20px;
    margin-bottom: 12px;

    .card-icon {
        width: 48px;
        height: 48px;
        border-radius: 12px;
        background: ${LINKEDIN_BLUE};
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .card-body {
        flex: 1;
        min-width: 0;
    }

    .connected-label {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-size: 13px;
        font-weight: 600;
        color: ${SUCCESS_GREEN};
    }

    .card-title {
        display: block;
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        color: var(--black);
        margin-bottom: 4px;
    }

    .card-subtitle {
        display: block;
        font-size: 13px;
        line-height: 18px;
        color: var(--gray-300, #777777);
    }

    .connect-btn {
        flex-shrink: 0;
        background: ${LINKEDIN_BLUE};
        color: var(--white);
        border: 0;
        border-radius: 50px;
        padding: 9px 22px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s ease;

        &:hover {
            background: ${LINKEDIN_BLUE_HOVER};
        }
    }
}

.continue-btn {
    display: block;
    margin-left: 60px;
    margin-top: 4px;
    background: none;
    border: 0;
    color: var(--gray-300, #777777);
    font-size: 13px;
    cursor: pointer;
    padding: 0;
    text-decoration: underline;

    &:hover {
        color: var(--black);
    }
}
`

export const StyledTemplateCanvas = styled.div`
width: 100%;
max-width: 600px;
height: clamp(240px, 42vh, 480px);
margin: 8px 0 16px;
overflow-y: auto;
border: 1px solid var(--gray-400, #E6E7EC);
border-radius: 16px;
background: radial-gradient(circle, #d5dae1 1.5px, transparent 1.5px);
background-size: 20px 20px;
background-color: var(--white);
animation: ${fadeSlideUp} 0.4s ease-out both;

.flow-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px 20px 36px;
}
`

export const StyledOnboardingHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: var(--white);
  transition: all ease-in-out 0.3s;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 30px;

  .logo-holder{
    max-width: 185px;

    img{
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .btn-holder{
    min-width: 260px;
    display: flex;
    align-items: center;
    gap: 20px;
  }
`;
